import { useCallback, useEffect, useState } from "react";
import DashboardGreeting from "../DashboardGreeting";
import DataTable from "react-data-table-component";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import * as XLSX from "xlsx";
import "jspdf-autotable";

import FilterIcon from "../../assets/images/filter.svg";
import ExportIcon from "../../assets/images/export.svg";

import SearchIcon from "../../assets/images/search.svg";
import moment from "moment";

import { useStateContext } from "../../contexts/ContextProvider";

import DailyLogsFilterModal from "../common/DailyLogsFilterModal";
import DailyLogsEditTime from "../common/DailyLogsEditTime";
import Success from "../common/CustomModals/Success";

import Select from "react-select";
import LogsService from "../../services/logs.service";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { fi } from "date-fns/locale";
import { Empty, Skeleton } from "antd";

const DailyLogs = ({ user }) => {
  const navHeading = "Daily Logs";

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const {
    filterBy,
    setFilterBy,
    editTime,
    setEditTime,
    success,
    setSuccess,
    // locations,
  } = useStateContext();

  const [date, setDate] = useState(new Date());
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const initialData = {
    empid: "",
    formatedDate: "Choose",
    formDate: "",
    formatedFromDate: "Choose",
    toDate: date,
    formatedToDate: "Choose",
    status: "Select",
    month: moment(new Date(date)).format("M"),
    year: moment(new Date(date)).format("YYYY"),
    location: "",
  };

  const [details, setDetails] = useState(initialData);

  const [locations, setLocations] = useState([]);

  const [myLogs, setMyLogs] = useState([]);
  const [search, setSearch] = useState("");
  const [checked, setChecked] = useState([]);

  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const fetchMyLogs = (payload) => {
    LogsService.getEmpMonthlyAttendenceLogs(payload)
      .then((resp) => {
        setMyLogs(resp.data);
      })
      .catch((e) => console.log(e));
  };

  const fetchMyLogsCurrent = () => {
    const date = new Date();
    const formDate = moment(date).startOf("month").format("YYYY-MM-DD");
    const month = moment(new Date(date)).format("M");
    const year = moment(new Date(date)).format("YYYY");
    const currentMonth = moment().format("M");
    let toDate;

    if (month === currentMonth) {
      // If selected month is current month → current date
      toDate = moment().format("YYYY-MM-DD");
    } else {
      // Else → end of the selected month
      toDate = moment(date).endOf("month").format("YYYY-MM-DD");
    }

    const payload = {
      empid: user && user.employeeCodeInDevice,
      fromdate: formDate,
      todate: toDate,
      month: month,
      year: year,
    };

    fetchMyLogs(payload);
  };

  useEffect(() => {
    fetchMyLogsCurrent();
  }, []);

  const showFilter = (e) => {
    e.preventDefault();
    setFilterBy(true);
  };

  const handleDateChange = (e) => {
    setDate(e.value);
    const formDate = moment(e.value).startOf("month").format("YYYY-MM-DD");
    const month = moment(new Date(e.value)).format("M");
    const year = moment(new Date(e.value)).format("YYYY");
    const currentMonth = moment().format("M");
    let toDate;

    if (month === currentMonth) {
      // If selected month is current month → current date
      toDate = moment().format("YYYY-MM-DD");
    } else {
      // Else → end of the selected month
      toDate = moment(e.value).endOf("month").format("YYYY-MM-DD");
    }

    // fetchMyLogs
    const payload = {
      empid: user && user.employeeCodeInDevice,
      fromdate: formDate,
      todate: toDate,
      month: month,
      year: year,
    };
    if (user.role === "2" || user.role === "3") {
      fetchMyLogs(payload);
    }

    setDetails((prevState) => ({
      ...prevState,
      month: month,
      year: year,
      formDate: formDate,
      toDate: toDate,
    }));
  };

  const columns = [
    {
      name: "Date",
      selector: (row) => row.logdate,
      cell: (row) => (
        <>
          <span className="strong" title={`${row.logdate}`}>
            {row.logdate}
          </span>
        </>
      ),
      sortable: true,
      width: "125px",
    },
    {
      name: "In Time",
      selector: (row) => row.intime,
      cell: (row) => (
        <>
          <span title={`${row.intime}`}>{`${row.intime}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Out Time",
      selector: (row) => row.outtime,
      cell: (row) => (
        <>
          <span title={`${row.outtime}`}>{`${row.outtime}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Working Hours",
      selector: (row) => row.todaysWhourse,
      cell: (row) => (
        <>
          <span title={`${row.todaysWhourse}`}>{`${row.todaysWhourse}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Location",
      selector: (row) => row.location,
      cell: (row) => (
        <>
          <span>{row.location}</span>
        </>
      ),
      sortable: true,
      omit: user.role === "3",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <>
          <div
            className={`${
              row.latemarkSts === "0" && row.status === "Present"
                ? "status present"
                : row.latemarkSts === "1"
                  ? "status latemark"
                  : row.status === "Absent" && row.leaveStatus === "OnLeave"
                    ? "status leave"
                    : row.status === "Absent" &&
                        row.leaveStatus === "OnHalfDayLeave"
                      ? "status halfDay"
                      : row.status === "Absent" &&
                          (row.holidaysts === "WorkDay" ||
                            row.holidaysts === "0" ||
                            row.holidaysts === null)
                        ? "status absent"
                        : row.holidaysts === "Weekoff" || row.holidaysts === "1"
                          ? "status"
                          : "status"
            }`}
          >
            {row.latemarkSts === "0" && row.status === "Present" ? (
              <>
                <span title={row.status}>{row.status}</span>
              </>
            ) : row.latemarkSts === "1" ? (
              <span title="Late Mark">Late Mark</span>
            ) : row.holidaysts === "Weekoff" || row.holidaysts === "1" ? (
              <>
                <span title="Week Off">Week Off</span>
              </>
            ) : row.status === "Absent" && row.leaveStatus !== "" ? (
              <>
                <span title={row.leaveStatus}>{row.leaveStatus}</span>
              </>
            ) : (
              <>
                <span title={row.status}>{row.status}</span>
              </>
            )}
          </div>
        </>
      ),
      sortable: true,
    },
    {
      name: "Platform",
      selector: (row) => row.platform,
      cell: (row) => (
        <>
          <div
            className={
              row.platform === "1"
                ? "status elms"
                : row.platform === "2"
                  ? "status attendrix"
                  : "status"
            }
          >
            <span>
              {" "}
              {row.platform === "1"
                ? "eSSL"
                : row.platform === "2"
                  ? "Attendrix"
                  : "-"}
            </span>
          </div>
        </>
      ),
      sortable: true,
      omit: user.role === "3",
    },
  ];

  const handleCheckedChange = (type) => (e) => {
    if (e.target.checked) {
      setChecked((prev) => [...prev, type]);
    } else {
      setChecked((prev) => prev.filter((item) => item !== type));
    }
  };

  const onFilterData = () => {
    let filteredData = myLogs;

    const objectValues = {
      empid: details.empid,
      location: details.location,
    };

    const nonEmptyDetails = Object.fromEntries(
      Object.entries(objectValues).filter(
        ([_, value]) => value !== "" && value !== null,
      ),
    );

    // console.log("checked", checked);

    filteredData = filteredData.filter((item) => {
      // Check status-based filters if any are selected
      if (checked.length > 0) {
        const statusMatch = checked.some((filter) => {
          if (filter === "Late Mark") {
            return item.latemarkSts === "1";
          }
          if (filter === "OnLeave") {
            return item.leaveStatus === "OnLeave";
          }
          if (filter === "Half Day") {
            return item.leaveStatus === "Half Day Leave";
          }
          if (filter === "Week Off") {
            return item.holidaysts === "Weekoff";
          }
          // For regular status values like "Present", "Absent"
          return (
            item.status === filter &&
            item.latemarkSts === "0" &&
            item.holidaysts === "WorkDay"
          );
        });

        if (!statusMatch) return false;
      }

      // Check additional filters (e.g., empid)
      return Object.entries(nonEmptyDetails).every(
        ([detailsKey, value]) => item[detailsKey] === value,
      );
    });

    setFilter(true);
    setFilteredData(filteredData);
  };

  const handleFilter = () => {
    if (details.formDate !== "" && details.toDate !== "") {
      const formDate = moment(details.formDate).format("YYYY-MM-DD");
      const toDate = moment(details.toDate).format("YYYY-MM-DD");
      const month = moment(new Date(details.formDate)).format("M");
      const year = moment(new Date(details.formDate)).format("YYYY");

      const payload = {
        empid: user && user.employeeCodeInDevice,
        fromdate: formDate,
        todate: toDate,
        month: month,
        year: year,
      };

      LogsService.getEmpMonthlyAttendenceLogs(payload)
        .then((resp) => {
          let filteredData = resp.data;

          const objectValues = {
            empid: details.empid,
            location: details.location,
          };

          const nonEmptyDetails = Object.fromEntries(
            Object.entries(objectValues).filter(
              ([_, value]) => value !== "" && value !== null,
            ),
          );

          // console.log("checked", checked);

          filteredData = filteredData.filter((item) => {
            // Check status-based filters if any are selected
            if (checked.length > 0) {
              const statusMatch = checked.some((filter) => {
                if (filter === "Late Mark") {
                  return item.latemarkSts === "1";
                }
                if (filter === "OnLeave") {
                  return item.leaveStatus === "OnLeave";
                }
                if (filter === "Half Day") {
                  return item.leaveStatus === "Half Day Leave";
                }
                if (filter === "Week Off") {
                  return item.holidaysts === "Weekoff";
                }
                // For regular status values like "Present", "Absent"
                return (
                  item.status === filter &&
                  item.latemarkSts === "0" &&
                  item.holidaysts === "WorkDay"
                );
              });

              if (!statusMatch) return false;
            }

            // Check additional filters (e.g., empid)
            return Object.entries(nonEmptyDetails).every(
              ([detailsKey, value]) => item[detailsKey] === value,
            );
          });

          setFilter(true);
          setFilteredData(filteredData);
        })
        .catch((e) => console.log(e));
    } else {
      onFilterData();
    }
    setFilterBy(false);
  };

  const clearFilter = () => {
    setFilter(false);
    setSearch("");
    setChecked([]);
    setFilterBy(false);
    setDetails(initialData);
    setFromDate("");
    setToDate("");
    fetchMyLogsCurrent();
    // setLoading(true);
  };

  const exportLogs = async (e, columns, data, reportName) => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Attendance");

    sheet.views = [
      {
        state: "frozen",
        xSplit: 0,
        ySplit: 5,
      },
    ];

    /* ===== TITLE ===== */
    sheet.mergeCells("B2:I2");
    sheet.getCell("B2").value = reportName;
    sheet.getCell("B2").font = { bold: true, size: 14 };
    sheet.getCell("B2").alignment = { horizontal: "center" };

    /* ===== DATE RANGE ===== */
    sheet.mergeCells("B4:I4");
    sheet.getCell("B4").value = `${moment(details.formDate).format(
      "MMM DD YYYY",
    )}  To  ${moment(details.toDate).format("MMM DD YYYY")}`;
    sheet.getCell("B4").alignment = { horizontal: "center" };

    const startCol = 1; // A
    const endCol =
      reportName === "Todays Logs" ? columns.length : columns.length + 1;

    for (let col = startCol; col <= endCol; col++) {
      sheet.getCell(5, col).border = {
        bottom: { style: "medium", color: { argb: "FF000000" } },
      };
    }

    let currentRow = 8;

    if (reportName === "Todays Logs") {
      columns.splice(2, 1); // Remove "Date" column
    }

    const headerRow = sheet.addRow(["", ...columns.map((col) => col.name)]);

    currentRow += 1;

    headerRow.eachCell((cell, colNumber) => {
      if (colNumber === 1) return; // Skip column A

      cell.font = { bold: true };
      cell.alignment = { horizontal: "left" };
      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };
    });

    data.forEach((day) => {
      currentRow++;
      const status =
        day.latemarkSts === 0 && day.status === "Present"
          ? day.status
          : day.latemarkSts === 1
            ? "Late Mark"
            : day.holidaysts === "Weekoff" || day.holidaysts === 1
              ? "Week Off"
              : day.status === "Absent" && day.leaveStatus !== ""
                ? day.leaveStatus
                : day.status;
      const platform =
        day.platform === "1"
          ? "eSSL"
          : day.platform === "2"
            ? "Attendrix"
            : "-";

      const rowData = [
        "",
        day.empid || "",
        day.name || "",
        moment(day.logdate).format("DD-MMM-YYYY") || "",
        day.intime || "",
        day.outtime || "",
        day.todaysWhourse || "",
        day.location || "",
        status || "",
        platform || "",
      ];

      if (reportName === "Todays Logs") {
        rowData.splice(3, 1); // Remove "Date" column
      }

      const row = sheet.addRow(rowData);

      row.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      });

      sheet.getCell(`N${row.number}`).alignment = {
        horizontal: "left",
        vertical: "middle",
      };
    });

    /* ===== COLUMN WIDTH ===== */
    sheet.columns = [
      { width: 2 },
      { width: 10 },
      { width: 25 },
      { width: 12 },
      { width: 10 },
      { width: 15 },
      { width: reportName === "Todays Logs" ? 18 : 10 },
      { width: reportName === "Todays Logs" ? 10 : 18 },
      { width: 10 },
      { width: 10 },
      { width: 14 },
      { width: 12 },
      { width: 12 },
    ];

    const START_COL = 1; // A
    const END_COL =
      reportName === "Todays Logs" ? columns.length : columns.length + 1;

    const statusCol = reportName === "Todays Logs" ? 8 : 9;
    const platformCol = reportName === "Todays Logs" ? 9 : 10;

    sheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      for (let col = START_COL; col <= END_COL; col++) {
        const cell = row.getCell(col); // <-- forces cell creation

        const statusCell = row.getCell(statusCol);
        const platformCell = row.getCell(platformCol);

        // console.log("statusCell", statusCell, statusCell.address);

        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFFFF" }, // white
        };

        const data = ["H2", "H4", "I2", "I4"];

        if (
          statusCell.value === "" ||
          statusCell.value === null ||
          statusCell.value === undefined ||
          statusCell.value === "Status" ||
          statusCell.address.includes("H2") ||
          statusCell.address.includes("H4") ||
          statusCell.address.includes("I2") ||
          statusCell.address.includes("I4")
        ) {
          statusCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "fffffff" }, // White
          };
        } else if (
          statusCell.value !== "Present" ||
          statusCell.value !== "Holiday" ||
          statusCell.value !== "Late Mark" ||
          statusCell.value !== "Absent" ||
          statusCell.value !== "Week Off" ||
          statusCell.value !== null
        ) {
          statusCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "fed2c8" }, // Red
          };
        }

        if (statusCell.value === "Present") {
          statusCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "c2f2dc" }, // Green
          };
        }

        if (statusCell.value === "Holiday") {
          statusCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "fff5c7" }, // Yellow
          };
        }

        if (statusCell.value === "Late Mark") {
          statusCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "fed2c8" }, // Yellow
          };
        }

        if (statusCell.value === "Absent") {
          statusCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "fb6240" }, // Red
          };
        }

        if (statusCell.value === "Week Off") {
          statusCell.font = { bold: true };
        }

        if (platformCell.value === "eSSL") {
          platformCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "fed2c8" }, // Red
          };
        }

        if (platformCell.value === "Attendrix") {
          platformCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFADD8E6" }, // blue
          };
        }

        // Optional: clear borders if needed
        // cell.border = {};
      }
    });

    sheet.views = [{ showGridLines: false }];

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], { type: "application/octet-stream" }),
      `${reportName}.xlsx`,
    );
  };

  return (
    <>
      <div className="dashboard-container dailyLogs">
        <DashboardGreeting navHeading={navHeading} user={user} />
        <div className="filterBar mb-3">
          <div className="sort-filter filter topbar">
            <div className="new-calendar-type flex justify-content-center">
              <Calendar
                value={date}
                onChange={handleDateChange}
                view="month"
                dateFormat="M, yy"
                style={{ height: "100%" }}
                showIcon
                selectOtherMonths
              />
            </div>

            <div className="filter" onClick={showFilter}>
              <img src={FilterIcon} alt="" />
            </div>
          </div>
        </div>
        <div className="recent-leave logs mb-3">
          <div className="heading mb-2">
            <span>All Logs</span>
          </div>
        </div>
        <DataTable
          columns={columns}
          data={filter ? filteredData : myLogs}
          fixedHeader
        />

        <div
          className={`${filterBy ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setFilterBy(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <DailyLogsFilterModal
              user={user}
              details={details}
              setDetails={setDetails}
              tabIndex={1}
              checked={checked}
              handleCheckedChange={handleCheckedChange}
              handleFilter={handleFilter}
              clearFilter={clearFilter}
              fromDate={fromDate}
              setFromDate={setFromDate}
              toDate={toDate}
              setToDate={setToDate}
            />
          </div>
        </div>

        <div
          className={`${editTime ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setEditTime(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <DailyLogsEditTime />
          </div>
        </div>

        <div
          className={`${success ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setSuccess(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <Success
              heading="Time updated successfully !"
              para="You can check your updated log on ‘ Daily Logs ‘ page"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DailyLogs;
